module.exports = "https://cdn-shared.mathletics.com/teacher-modules/curriculum-manager/15assets/fonts/af7ae505a9eed503f8b8e6982036873e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0
// module id = 670
// module chunks = 4